import vue from "../main"
import { localStorages } from "./localStorages";
import { messages } from "./messages";

const findVaildMenu = (Menu) => {
  // Menu为父菜单，找到该父菜单下第一个非禁用的菜单`
  let i = 0;
  while (i < Menu.length) {
    if (Menu[i].disabled === false) {
      break;
    }
    i++;
  }
  if (i === Menu.length) i = 0; // 当全部子菜单为禁用?
  return i;
}

const getSystemUrl = (url) => {
  let prefix = `${window.location.protocol}//${window.location.host}`
  if (url.startsWith("http://") || url.startsWith("https://")) {
  } else {
    url = prefix + url
  }
  url = url +
  "?id_token=" +
  localStorages.getItem("id_token") +
  "&refresh_token=" +
  localStorages.getItem("refresh_token") +
  "&people_id=" +
  localStorages.getItem("peopleId") +
  "&identity_id=" +
  localStorages.getItem("userId") +
  "&tenant_id=" +
  localStorages.getItem("tenantId")
  return url
}

const enterSystemInRouterGuards = async (next) => { // 判断系统权限，及相应跳转逻辑 start
  vue.$store
  .dispatch("getMenuTree", {
    peopleId: localStorages.getItem("userId")
  })
  .then(menus => {
    let user;
    let params = {
      identityId: localStorages.getItem("userId")
    };
    vue.$store.dispatch("getPerson", {params: params}).then(res => {
      user = res;
      if (user.roleType === 0) { // 单元管理员不显示会议入口
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].name === "智慧会议") {
            menus.splice(i, 1);
            break;
          }
        }
      }
      if (menus.length === 0) {
        let msg = messages.noaccessauth.copy();
        msg.message = "没有系统权限";
        msg.fireAsync();
      } else {
        if (menus.length === 1) {
          // 只有一个系统
          // savecookie(
          //   "moduleSign",
          //   `${menus[0].sign}${menus[0].moduleId}-`,
          //   1
          // );
          if (menus[0].moduleId === 1) {
            // 跳转到基础平台
            let parentMenu = menus[0].children; // 找到该系统下的父菜单
            let parentIndex = findVaildMenu(parentMenu);
            // 找到该父菜单下的第一个可用子菜单
            let childMenu = parentMenu[parentIndex];
            let childIndex;
            while (
              childMenu.children !== undefined &&
              childMenu.children.length !== 0
            ) {
              childIndex = findVaildMenu(childMenu);
              childMenu = childMenu.children[childIndex];
            }
            // let endindex = window.location.href.indexOf("#") + 1; // 找到路由中#位置
            // let nowurl = window.location.href.substring(0, endindex); // 分割路由
            next(childMenu.url);
            // window.location.href = nowurl+childMenu.url //拼接有权限路由
          } else {
            // let nowurl =
            //   menus[0].url +
            //   "?id_token=" +
            //   localStorages.getItem("id_token") +
            //   "&refresh_token=" +
            //   localStorages.getItem("refresh_token") +
            //   "&people_id=" +
            //   localStorages.getItem("peopleId") +
            //   "&identity_id=" +
            //   localStorages.getItem("userId") +
            //   "&tenant_id=" +
            //   localStorages.getItem("tenantId");
            let nowurl = getSystemUrl(menus[0].url)
            window.location.href = nowurl;
          }
          // else if (menus[0].moduleId === 59) {
          //   //跳转到空间平台
          //   window.location.href =
          //     menus[0].url +
          //     "?id_token=" +
          //     localStorages.getItem("id_token") +
          //     "&refresh_token=" +
          //     localStorages.getItem("refresh_token") +
          //     "&account_id=" +
          //     localStorages.getItem("userId");
          // } else {
          //   //跳转到出入，会议平台
          //   window.location.href =
          //     menus[0].url +
          //     "?id_token=" +
          //     localStorages.getItem("id_token") +
          //     "&refresh_token=" +
          //     localStorages.getItem("refresh_token");
          // }
        } else {
          next("/systemEnter");
        }
      }
    }).catch(fail => {
      if (fail) {
        messages.warning(fail.message);
      }
    })
  }).catch(fail => {
    if (fail) messages.warning(fail.message);
  })
}

export default {
  findVaildMenu,
  getSystemUrl,
  enterSystemInRouterGuards
}



// WEBPACK FOOTER //
// ./src/utils/enterSystem.js